import React, { useEffect,useState  } from "react";
import { Link, useParams } from "react-router-dom";
import Auth_Actions from "../../redux/auth/actions";
import LazyLoad from "react-lazyload";
import "./silentauction.css";
import { useDispatch, useSelector } from "react-redux";
import silent_Action from "../../redux/silent_auction/actions";

export default function SilentAuction() {
  const dispatch = useDispatch();
  const {shortcode} = useParams();
  const Auth = useSelector((state) => state.Auth);
  const Silent = useSelector((state) => state.SilentAuction);
  //let { CategoryID } = useParams();
  const [CategoryID, setCategoryID] = useState('');

  const [filter, setFilter] = useState('');

  const fetchSilentItems = () => {
    if (shortcode) {
      dispatch(Auth_Actions.auction({ShortCode: shortcode,afterAction: () => {

        if (CategoryID) {
          if (CategoryID === "all") {
            dispatch(
              silent_Action.silentItems({
                auctionId: Auth.auctionData.Id,
                token: Auth?.auth?.access_token,
              })
            );
          } else {
            dispatch(
              silent_Action.silentItemByCategory({
                auctionId: Auth.auctionData.Id,
                categoryId: CategoryID,
                token: Auth?.auth?.access_token,
              })
            );
          }
        } else {
          //if (!Silent.items && Auth.auctionData) {
          if (Auth.auctionData) {
            dispatch(
              silent_Action.silentItems({
                auctionId: Auth.auctionData.Id,
                token: Auth?.auth?.access_token,
              })
            );
          }
        }

      }}));
    } 

  }

  useEffect(() => {
    console.log(shortcode); 
    fetchSilentItems();
  
  }, [CategoryID,dispatch,silent_Action.silentItems,Auth.auctionData?.Id]);

  useEffect(() => {
    if (!Silent.itemsByCategory && Auth.auctionData) {
      dispatch(
        silent_Action.silentItemsByCategory({
          auctionId: Auth.auctionData.Id,
          token: Auth?.auth?.access_token,
        })
      );
    }
  }, [Auth.auctionData,dispatch]);

let categoryChange = (event) => {
  setFilter('');  
  setCategoryID(event.target.value);
  //CategoryID = event.target.value;
  //window.location.href = '/silent-auction/' + event.target.value;

};

const AddWatchlist = (itemId, event) => {
  event.preventDefault();
  var response = dispatch(silent_Action.addWatchlist({
    itemId: itemId,
    token: Auth.auth.access_token,
    afterAction: () => {
      fetchSilentItems();
    }
  }));
}

const RemoveFromWatchlist = (itemId, event) => {
  event.preventDefault();
  var response = dispatch(silent_Action.removeFromWatchlist({
    itemId: itemId,
    token: Auth.auth.access_token,
    afterAction: () => {
      fetchSilentItems();
    }
  }));
}

  // Create our number formatter.
  const formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    currency: "USD",
  });
  
  return (
    <div>
      <section className="section novi-bg novi-bg-img breadcrumbs-custom">
        <div className="container">
          <div className="breadcrumbs-custom__inner">
            <p className="breadcrumbs-custom__title">Silent Auction</p>
            <ul className="breadcrumbs-custom__path">
              <li>
                <Link to={"/" + Auth.auctionData?.ShortCode}>Home</Link>
              </li>
              <li className="active">
                <Link to={"./silent-auction/" + Auth.auctionData?.ShortCode}>Silent Auction</Link>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section novi-bg novi-bg-img section-lg bg-default product-listing">
        <div className="container">
          <div className="row row-fix row-60 flex-lg-row-reverse">
            <div className="col-lg-9 section-divided__main section-divided__main-left">
              <div className="section-md">
                {                
                <div className="filter-shop-box row">
                  
                  <div className="form-wrap product-category mobileCategory">
                    <select onChange={categoryChange}
                      className="form-input select-filter categoryList"
                      data-placeholder="Default sorting"
                      data-minimum-results-for-search="Infinity"
                    >
                      <option>Categories</option>
                      {Silent.itemsByCategory?.map((item, k) => (
                        <option key={k} value={item.CategoryId}>
                          {item.Name} ({item.ItemCount})
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="search-icon-wrapper textFilter">
                    <input id="filter"
                      className="form-input"
                      name="filter"
                      type="text"
                      value={filter}
                      onChange={event => setFilter(event.target.value)}
                    />                  
                  </div>
                  

                </div> }
                <div className="row justify-content-sm-center row-70">
                  {Silent.items ? (
                    Silent.items.length > 0 ? (
                      Silent.items?.filter(f => f.LotNumber.toLowerCase().indexOf(filter.toLowerCase()) > -1 || f.Name.toLowerCase().indexOf(filter.toLowerCase()) > -1 || (filter === '')).map((item, k) => (
                        <div key={k} className="col-md-6 col-xl-4">
                          <div className="product product-grid">
                            <div className="product-img-wrap">
                              <Link
                                to={"/silent-auction/detail/" + item.ItemId + "/" + Auth.auctionData.ShortCode}
                              >
                                
                                  <img
                                    src={
                                      item?.Images?.length > 0
                                        ? item.Images[0].Url
                                        : "/assets/images/Item_ComingSoon.jpg"
                                    }
                                    alt=""
                                    width="300"
                                    height="400"
                                  />                                  
                                  {!item.IsWatchlist &&                   
                                    <button onClick={(event) => AddWatchlist(item.ItemId, event)} className="button-primary button watchlistButton watchlistIconPosition">
                                      <i class="far fa-heart fa-heart-style"></i>
                                    </button>  
                                  }  
                                  {item.IsWatchlist &&                   
                                    <button onClick={(event) => RemoveFromWatchlist(item.ItemId, event)} className="button-primary button watchlistButton watchlistButtonAfter watchlistIconPosition">
                                      <i class="far fa-heart fa-heart-style"></i>
                                    </button>   
                                  } 
                                
                              </Link>
                              {/* <div className="product-label-wrap"><span className="featured">Featured</span></div> */}
                            </div>
                            <div className="product-caption">
                              <p class="lotNumber">Lot # {item.LotNumber}</p>
                              <h6 className="product-title">
                                <Link
                                  to={"/silent-auction/detail/" + item.ItemId + "/" + Auth.auctionData.ShortCode}
                                >
                                   {item.Name}
                                </Link>
                              </h6>
                                {item.HighBid && 
                                  <ul className="product-categories">
                                  <li class="bidderName">
                                    High Bid:&nbsp;{item?.HighBid?.Bidder?.IsAnonymous || item.HighBid?.IsAnonymous ? "Anonymous" : item?.HighBid?.Bidder?.FirstName + " " + item?.HighBid?.Bidder?.LastName}
                                  </li>
                                </ul>                                  
                                }
                              
                              <Link
                                to={"/silent-auction/detail/" + item.ItemId + "/" + Auth.auctionData.ShortCode}
                                className="button-primary button button-icon button-icon-left bidButton"
                              >
                                {!item.IsBuyNow && 
                                   <span>                                  
                                   {item.HighBid && item?.HighBid?.Amount
                                     ? "$"+formatter.format(item?.HighBid?.Amount)
                                     : "$"+formatter.format(item?.StartingBid)}
                                 </span>
                                } 

                                {(item.IsBuyNow && !item.IsBidNowMaxBidShown)&&  
                                   <span>                                  
                                   {"$"+formatter.format(item?.BuyNowPrice)}
                                 </span>
                                 } 
                              
                                {(item.IsBuyNow && item.IsBidNowMaxBidShown) && 
                                   <span>                                  
                                   {item.HighBid && item?.HighBid?.Amount
                                     ? "$"+formatter.format(item?.HighBid?.Amount)
                                     : "$"+formatter.format(item?.StartingBid)}
                                 </span>
                                 } 
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (

<section className="my-acount">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div
                        style={{ paddingTop: "30px", paddingBottom: "30px" }}
                        className="text-center my-account-text"
                      >
                        <div className="blurb-minimal__icon">
                          <span className="icon novi-icon linear-icon-shield-alert"></span>
                        </div>
                        <p>No items in this category.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

                      

                    )
                  ) : (
                    <div id="page-loader">
                      <div className="cssload-container">
                        Loading...{" "}
                        <div className="cssload-speeding-wheel"></div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-3 section-divided__aside section__aside-left group-shop">
              <div className="section-md">
                <h5>Categories</h5>
                <ul className="small list categoryList">                  
                  {Silent.itemsByCategory?.map((item, k) => (
                    <li key={k} onClick={event => {setCategoryID(item.CategoryId); setFilter('');}}>
                        {item.Name} {`(${item.ItemCount})`}                        
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
